import React from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';


interface IProps extends ICellProps {
    onChange: (value: any) => void;
    disabled?: boolean;
};


// const TextInput = styled.input`
//     position: absolute;
//     display: block;
//     top:0;
//     left:0;
//     margin: 0;
//     height: 100%;
//     width: 100%;
//     border: none;
//     padding: 0;
//     box-sizing: border-box;
//     padding: 0 10px;
// `;

const DataBlock = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    font-size:12px;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
`;

const Text: React.FC<IProps> = (props: IProps) => {
  const checkedState = props.value ? Boolean(String(props.value).replace('meta-disable|', '')) : false;
  const disabledState = props.disabled || String(props.value).indexOf('meta-disable') !== -1 ? true : false;
  return <DataBlock><Checkbox disabled={disabledState} checked={checkedState} onChange={(e?:React.FormEvent<HTMLElement>, isChecked?: boolean) => {
    props.onChange && props.onChange(isChecked);
  }
  }
   /></DataBlock>;
}

export default Text;
